module.exports = __webpack_public_path__ + "img/credit-certification.51ddd4c9.png";